import { render, staticRenderFns } from "./JgpTags.vue?vue&type=template&id=11aab50b&"
import script from "./JgpTags.vue?vue&type=script&lang=js&"
export * from "./JgpTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports